import svgPanZoom from "svg-pan-zoom";
import Hammer from "hammerjs";

export default function initMap() {
	const map = document.getElementById("czech-map");
	if (!map) {
		return;
	}
	const points = map.querySelectorAll<SVGGElement>(".project-point");
	const hammer = new Hammer(map);
	return svgPanZoom(
		map,
		{
			controlIconsEnabled: true,
			minZoom: 1,
			onZoom: (newScale: number) => {
				for (const point of points) {
					point.setAttribute('transform', `scale(${1/newScale})`);
					// point.setAttribute('transform', `translate(${parseFloat(point.dataset.x) + (49 * (newScale-1) / 2)} ${parseFloat(point.dataset.y) + (64*(newScale-1) / 2)}) scale(${1/newScale})`);
					// const x = parseFloat(point.dataset.x);
					// const y = parseFloat(point.dataset.y);
					// const transform = `translate(${parseFloat(point.dataset.xp)}%, ${parseFloat(point.dataset.yp)}%) scale(${1/newScale})`;
					// console.log(transform);
					// point.style.transform = transform;
				}
			},
			customEventsHandler: {
				haltEventListeners: ['touchstart', 'touchend', 'touchmove', 'touchleave', 'touchcancel'],
				init: function(options) {
					const instance = options.instance;
					let initialScale = 1, pannedX = 0, pannedY = 0;

					hammer.get('pinch').set({enable: true});
					hammer.on('doubletap', () => {
						instance.zoomIn();
					});
					hammer.on('panstart panmove', (ev) => {
						// On pan start reset panned variables
						if (ev.type === 'panstart') {
							pannedX = 0
							pannedY = 0
						}

						// Pan only the difference
						instance.panBy({x: ev.deltaX - pannedX, y: ev.deltaY - pannedY})
						pannedX = ev.deltaX
						pannedY = ev.deltaY
					});

					hammer.on('pinchstart pinchmove', function(ev){
						// On pinch start remember initial zoom
						if (ev.type === 'pinchstart') {
							initialScale = instance.getZoom()
							instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
						}

						instance.zoomAtPoint(initialScale * ev.scale, {x: ev.center.x, y: ev.center.y})
					})

					// Prevent moving the page on some devices when panning over SVG
					options.svgElement.addEventListener('touchmove', function(e){ e.preventDefault(); });
				},
				destroy: () => {
					hammer.destroy();
				}
			}
		}
	);
}
